import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import {
	displayPhone, 
	displayDateFromTimestamp, 
	getDiamondImage, 
	getDiamondImagePlaceholder, 
	formatDiamondTitle, 
	formatMeasurements, 
	formatLocation, 
	formatCut, 
	formatCarat, 
	formatCost, 
	formatColor, 
	formatPrice, 
	formatClarity,
	getWatchThumbnailImage,
  getUrlId,
} from '../../../utils/formatting';

import RhinoLoading from '../common/RhinoLoading';
import {VideoPlayerContainer} from '../single-diamond/VideoPlayer';

import * as leadsActionCreators from '../../../actions/leads';
import * as watchActionCreators from '../../../actions/watches';
let allActionCreators = Object.assign({}, leadsActionCreators, watchActionCreators);

class ExternalWatch extends React.Component {

	constructor(props) {
		super(props);

    this.shareId = parseInt(getUrlId());

    this.state = {
      cardId: this.shareId,
      card: null,
      associate: null,
      location: null,
      diamonds: [],
      includeGia: false,
      includePrice: false,
      includeImage: false,
      includeVideo: false,
      message: '',
      watches: [],
      watchSkus: [],
      watchesLoading: false,
    }

    if(this.state.card === null) {

      this.props.fetchExternalShare(this.shareId)
      .then((respData) => {
        this.setState({ 
          card: respData.share.card ? respData.share.card : '',
          associate: respData.share.associate ? respData.share.associate : '',
          location: respData.share.location ? respData.share.location : '',
          diamonds: respData.share.diamonds,
          includeGia: respData.share.include_gia,
          includePrice: respData.share.include_price,
          includeImage: respData.share.include_image,
          includeVideo: respData.share.include_video,
          message: respData.share.message,
          watchSkus: respData.share.watch_skus,
          watchesLoading: respData.share.watch_skus && respData.share.watch_skus.length > 0 ? true : false,
        });

        if(respData.share.watch_skus && respData.share.watch_skus.length > 0) {
        	for(const watchSku of respData.share.watch_skus) {
        		this.fetchWatch(watchSku);
        	}
        }
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    }
	}

	fetchWatch(watchSku) {
		this.props.fetchSingleWatch(watchSku)
    .then((respData) => {

    	const newWatches = [];
    	for(const watch of this.state.watches) {
    		newWatches.push(watch);
    	}
    	newWatches.push(respData.success);

      this.setState({ 
        watches: newWatches,
        watchesLoading: newWatches.length < this.state.watchSkus.length,
      });
    })
    .catch((errorResp) => {
      console.error(errorResp);
      this.setState({
        watchNotFound: true,
      })
    });
	}

  userNav(page) {
    history.push('/' + page);
  }

  getFullAddress() {
    
    if(this.state.card) {
      return this.state.card.location.address_street + ' ' + this.state.card.location.address_city + ' ' + this.state.card.location.address_state + ' ' + this.state.card.location.address_zip;  
    }
    if(this.state.location) {
      return this.state.location.address_street + ' ' + this.state.location.address_city + ' ' + this.state.location.address_state + ' ' + this.state.location.address_zip;  
    }
    return ''; 
  }

  getAddressLine1() {

    if(this.state.card) {
      return this.state.card.location.address_street;
    }
    if(this.state.location) {
      return this.state.location.address_street;
    }
    return ''; 
  }

  getAddressLine2() {
    
    if(this.state.card) {
      return this.state.card.location.address_city + ' ' + this.state.card.location.address_state + ' ' + this.state.card.location.address_zip;
    }
    if(this.state.location) {
      return this.state.location.address_city + ' ' + this.state.location.address_state + ' ' + this.state.location.address_zip;
    }
    return ''; 
  }

  getGoogleUrl() {
    if(this.state.card) {
      return 'https://www.google.com/maps/search/' + encodeURIComponent(this.getFullAddress());
    }
    if(this.state.location) {
      return 'https://www.google.com/maps/search/' + encodeURIComponent(this.getFullAddress());
    }
    return '#';
  }

	render() {
		return <div className='ExternalWatch'>
      {this.state.card === null ?
        <div className='leadLoading'>
          <RhinoLoading message='Loading information' />
        </div> :
        <div>
          <div className='shareWrapper'>
            <div className='shareInternalWrapper'>
              <div className='shareTitle'>Your Collection</div>
              <div className='shareHr'>
                <img src='/img/icons/lines/iconline_thin.svg' />
              </div>
              {this.state.message ?
                <div className='shareMessage'>{this.state.message}</div> :
                null
              }
              <div className='shareDiamonds'>
                {this.state.diamonds.map((diamond, i) => {
                  return <div className={'diamondElement'} key={i}>
                    {this.state.includeVideo && diamond.video !== null ?
                      <div className='videoWrapper'>
                        <VideoPlayerContainer diamondObj={diamond} isZoomed={false} />
                      </div> :
                      <div className='imageWrapper'>
                        <div className='imageInnerWrapper'>
                          {this.state.includeImage ?
                            <img src={getDiamondImage(diamond)} /> :
                            <img src={getDiamondImagePlaceholder(diamond)} />
                          }
                        </div>
                      </div>
                    }
                    <div className='titleWrapper'>{formatDiamondTitle(diamond)}</div>
                    {this.state.includeGia ?
                      <div className='giaWrapper'>{'GIA #: ' + diamond.gia_number}</div> :
                      null
                    }
                    {this.state.includePrice ?
                      <div className='priceWrapper'>{formatPrice(diamond)}</div> :
                      null
                    }
                    <div className='infoWrapper'>
                      <div className='infoElement'>
                        <div className='infoLabel'>Cut:</div>
                        <div className='infoValue'>{formatCut(diamond)}</div>
                      </div>
                      <div className='infoElement'>
                        <div className='infoLabel'>Color:</div>
                        <div className='infoValue'>{formatColor(diamond)}</div>
                      </div>
                      <div className='infoElement'>
                        <div className='infoLabel'>Carat:</div>
                        <div className='infoValue'>{formatCarat(diamond)}</div>
                      </div>
                      <div className='infoElement'>
                        <div className='infoLabel'>Clarity:</div>
                        <div className='infoValue'>{formatClarity(diamond)}</div>
                      </div>
                    </div>
                  </div>;
                })}
              </div>
              <div className='shareWatches'>
              	{this.state.watchesLoading ?
              		<div className='watchLoadingWrapper'>
              			<RhinoLoading message='Loading timepieces' />
              		</div> :
              		<div className='watchesWrapper'>
              			{this.state.watches.map((watch, j) => {
		                  return <div className={'diamondElement'} key={j}>
		                    
	                      <div className='imageWrapper'>
	                        <div className='imageInnerWrapper'>
	                          {this.state.includeImage ?
	                            <img src={getWatchThumbnailImage(watch)} /> :
	                            <img src={getWatchThumbnailImage({})} />
	                          }
	                        </div>
	                      </div>

		                    <div className='titleWrapper'>{watch.description}</div>
		                    {this.state.includePrice ?
		                      <div className='priceWrapper'>{formatPrice(watch)}</div> :
		                      null
		                    }
		                    <div className='infoWrapper'>
		                      <div className='infoElement'>
		                        <div className='infoLabel'>Movement:</div>
		                        <div className='infoValue'>{watch.movement ? watch.movement : ''}</div>
		                      </div>
		                      <div className='infoElement'>
		                        <div className='infoLabel'>Crystal Type:</div>
		                        <div className='infoValue'>{watch.crystal ? watch.crystal : ''}</div>
		                      </div>
		                      <div className='infoElement'>
		                        <div className='infoLabel'>Dial Color:</div>
		                        <div className='infoValue'>{watch.dial_color ? watch.dial_color : ''}</div>
		                      </div>
		                      <div className='infoElement'>
		                        <div className='infoLabel'>Case Material:</div>
		                        <div className='infoValue'>{watch.case_material ? watch.case_material : ''}</div>
		                      </div>
		                      <div className='infoElement'>
		                        <div className='infoLabel'>Case Size:</div>
		                        <div className='infoValue'>{parseFloat(watch.case_size) ? `${watch.case_size} mm` : ''}</div>
		                      </div>
		                      <div className='infoElement'>
		                        <div className='infoLabel'>Band Material:</div>
		                        <div className='infoValue'>{watch.band_material ? watch.band_material : ''}</div>
		                      </div>
		                    </div>
		                  </div>;
		                })}
              		</div>
              	}
              </div>
              {this.state.card ?
                <div className='shareAssociate'>
                  <div className='blockTitle'>Your Personal Jeweler</div>
                  <div className='associateName'>{this.state.card.associate.first_name + ' ' + this.state.card.associate.last_name}</div>
                  <div className='associateContactWrapper'>
                    <a href={'mailto:' + this.state.card.associate.email} className={'associateContactButton actionButton'}>Contact</a>
                  </div>
                </div> :
                <div>
                  {this.state.associate ?
                    <div className='shareAssociate'>
                      <div className='blockTitle'>Your Personal Jeweler</div>
                      <div className='associateName'>{this.state.associate.first_name + ' ' + this.state.associate.last_name}</div>
                      <div className='associateContactWrapper'>
                        <a href={'mailto:' + this.state.associate.email} className={'associateContactButton actionButton'}>Contact</a>
                      </div>
                    </div> :
                    null
                  }
                </div>
              }
              {this.state.card ?
                <div className='shareLocation'>
                  <div className='blockTitle'>Your Diamonds Direct Store</div>
                  <div className='locationName'>{this.state.card.location.full_name}</div>
                  <div className='locationAddress'>{this.getFullAddress()}</div>
                  <div className='locationMobileAddress'>{this.getAddressLine1()}</div>
                  <div className='locationMobileAddress'>{this.getAddressLine2()}</div>
                  <div className='locationDirectionsWrapper'>
                    <a href={this.getGoogleUrl()} target='_blank' className={'locationDirectionsButton actionButton'}>Directions</a>
                  </div>
                </div> :
                <div>
                  {this.state.location ?
                    <div className='shareLocation'>
                      <div className='blockTitle'>Your Diamonds Direct Store</div>
                      <div className='locationName'>{this.state.location.full_name}</div>
                      <div className='locationAddress'>{this.getFullAddress()}</div>
                      <div className='locationMobileAddress'>{this.getAddressLine1()}</div>
                      <div className='locationMobileAddress'>{this.getAddressLine2()}</div>
                      <div className='locationDirectionsWrapper'>
                        <a href={this.getGoogleUrl()} target='_blank' className={'locationDirectionsButton actionButton'}>Directions</a>
                      </div>
                    </div> :
                    null
                  }
                </div>
              }
              <div className='logoWrapper'>
                <img src='/img/login/logotag.svg' />
              </div>
            </div>
          </div>
        </div>
      }
    </div>;
	}
}
export default ExternalWatch;

function mapStateToProps(state) {
  return {
    leads: state.leads,
  };
}

export const ExternalWatchContainer = connect(
  mapStateToProps,
  allActionCreators
)(ExternalWatch);